import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row research-item" }
const _hoisted_2 = { class: "research-item-icon iodine-padding-right-md" }
const _hoisted_3 = { class: "col iodine-label research-item-label" }
const _hoisted_4 = ["innerHTML"]

import {useTrucodeReferenceStore} from "stores/references-store";
  import {useQuasar} from "quasar";
  import { MetadataResearchArticle } from 'src/contracts/getMetadataResearchResponse';
  import { useGrouperStore } from 'stores/grouper-store';
  import { useLayoutStore } from 'stores/layout-store';
  import { useSearchStore } from 'stores/search-store';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchItem',
  props: {
    researchItemDataModel: {}
  },
  setup(__props: any) {

  const props = __props;

  const $q = useQuasar()

  function openResearch(researchItemDataModel: MetadataResearchArticle) {

    if (researchItemDataModel.link) {
      window.open(researchItemDataModel.link, '_blank', 'resizable=yes,scrollbars=yes,width=1440,height=1024,left=0,top=0');
    } else {
      const response = useTrucodeReferenceStore().getReferencesArticle('' + researchItemDataModel.id);
      response.then(data => {
        if(data) {
          $q.dialog({
            color: 'white',
            html: true,
            focus: 'none',
            message: data,
            ok: {
              class: 'dialog-button',
              label: 'Close'
            },
            class: 'io-mfe-ig-research-dialog'
          })
        }
      });
    }
  }

  function handleEmbeddedClick(event: any) {
    const code = event?.target?.text;


    if (event?.target?.dataset?.codeType == 'ICD10CM_DX' || event?.target?.dataset?.codeType == 'ICD10CM_E') {
      const diagnoseExist = useGrouperStore().diagnosisCodes.some(diagnose => diagnose.code === code);

      if(diagnoseExist) {
        useLayoutStore().setCodesSelected(true);
        useGrouperStore().changeSelectedCode(code)
      } else {
        useLayoutStore().setSearchSelected(true);
        useSearchStore().changeSearchText(code);
      }
    } else if (event?.target?.dataset?.codeType?.startsWith('ICD10PCS')) {
      const procedureExist = useGrouperStore().procedureCodes.some(procedure => procedure.code === code);

      if(procedureExist) {
        useLayoutStore().setCodesSelected(true);
        useGrouperStore().changeSelectedCode(code)
      } else {
        useLayoutStore().setSearchSelected(true);
        useSearchStore().changeSearchText(code);
      }
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_icon, {
        name: "fa-solid fa-circle",
        size: "6px",
        color: "primary"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        onClick: handleEmbeddedClick,
        class: "research-item-content",
        innerHTML: props.researchItemDataModel.text
      }, null, 8, _hoisted_4),
      _createElementVNode("span", null, [
        _createElementVNode("a", {
          class: "research-item-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openResearch(props.researchItemDataModel)))
        }, _toDisplayString(props.researchItemDataModel.title), 1)
      ]),
      _withDirectives(_createElementVNode("span", null, " , ", 512), [
        [_vShow, props.researchItemDataModel.issue_title]
      ]),
      _withDirectives(_createElementVNode("span", { class: "research-item-subtitle" }, "  " + _toDisplayString(props.researchItemDataModel.issue_title), 513), [
        [_vShow, props.researchItemDataModel.issue_title !== '']
      ])
    ])
  ]))
}
}

})